import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconShop';
/** Renders an SVG icon. */
const SvgShop = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M18.002 26v-5h-4v5a1 1 0 1 1-2 0v-5a2 2 0 0 1 2-2h4l.204.01A2 2 0 0 1 20.002 21v5a1 1 0 1 1-2 0M22 4a3 3 0 0 1 2.4 1.2l3.593 4.79a3.515 3.515 0 0 1-4.761 5.033l-.286-.191a1.7 1.7 0 0 0-1.89 0 3.7 3.7 0 0 1-4.11 0 1.7 1.7 0 0 0-1.89 0 3.7 3.7 0 0 1-4.11 0 1.7 1.7 0 0 0-1.89 0l-.287.19a3.514 3.514 0 0 1-4.76-5.033L7.6 5.2A3 3 0 0 1 10 4zM10 6a1 1 0 0 0-.8.4l-3.592 4.79a1.515 1.515 0 0 0 2.052 2.168l.286-.19a3.7 3.7 0 0 1 4.11 0 1.7 1.7 0 0 0 1.89 0 3.7 3.7 0 0 1 4.11 0 1.7 1.7 0 0 0 1.89 0 3.7 3.7 0 0 1 4.11 0l.285.19a1.515 1.515 0 0 0 2.052-2.168L22.801 6.4a1 1 0 0 0-.8-.4z"
      />
      <path
        fill="currentColor"
        d="M6.002 25V14.95a1 1 0 1 1 2 0V25a1 1 0 0 0 1 1H23a1 1 0 0 0 1-1V14.95a1 1 0 0 1 2 0V25a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3Z"
      />
    </svg>
  );
};
SvgShop.displayName = displayName;
export default SvgShop;
